<script>
  import { getContext } from 'svelte';
  import EventGeneral from '../forms/event.general';
  import EventStatus from '../forms/event.status';

  import SectionNav from '../../../../components/navigation/section';
  import Link from '../../../../utils/link';
  import { UPDATE_EVENT } from '../../../../graphql/events';
  import { addNotification, ICONS } from '../../../../utils/notifications.store';
  import moment from 'moment';

  export let value;
  let current = EventGeneral;

  const client = getContext('apollo');

  async function save() {
    const input = {
      name: value.program.name,
      category: value.program.category.id,
      secondaryCategory: value.program.secondaryCategory.id,
      program: value.program.id,
      date: value.date,
      startTime: moment(value.startTime).format('h:mm A'),
      endTime: moment(value.endTime).format('h:mm A'),
      staffStartTime: value.staffStartTime && value.staffStartTime !== 'Invalid date' ? moment(value.staffStartTime).format('h:mm A') : null,
      staffEndTime: value.staffEndTime && value.staffEndTime !== 'Invalid date' ? moment(value.staffEndTime).format('h:mm A') : null,
      constraintCapacityTotal: parseInt(value.constraintCapacityTotal || 0),
      constraintStaff: parseInt(value.constraintStaff || 0),
      constraintAllowEarlyRegistration:
        value.constraintAllowEarlyRegistration || false,
      constraintAllowGroupRegistration:
        value.constraintAllowGroupRegistration || false,
      constraintCapacityGroup: parseInt(value.constraintCapacityGroup || 0),
      leader: value.leader.id,
      notes: value.notes,
      published: value.published,
      registrationOpenDate: value.registrationOpenDate,
      earlyRegistrationOpenDate: value.earlyRegistrationOpenDate,
      constraintPrivate: value.constraintPrivate || false,
      published: value.published,
      constraintCapacityPublic:
        parseInt(value.constraintCapacityTotal) -
        parseInt(value.constraintCapacityGroup || 0)
    };

    if (value.id) {
      input.id = value.id;
    }

    const variables = {
      input
    };

    try {
      addNotification({ icon: ICONS.LOADING, message: `Saving ${value.name}` });

      const { data } = await client.mutate({ mutation: UPDATE_EVENT, variables });



      addNotification({
        time: 3000,
        message: `Successfully Saved ${input.name}`,
        icon: ICONS.SUCCESS
      });
    } catch (e) {
      addNotification({
        message: `Error Saving ${input.name}`,
        icon: ICONS.ERROR
      });
    }
  }

  function changeComponent(componentToChange) {
    current = componentToChange;
  }

</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-9">
    <svelte:component this={current} bind:value={value} />
  </div>
  <div class="cell small-12 medium-3">
    <SectionNav>
      <ul>
        <li class:active={current==EventGeneral} on:click="{() => changeComponent(EventGeneral)}">
          General
        </li>
        <li class:active={current==EventStatus} on:click="{() => changeComponent(EventStatus)}">
          Status
        </li>

      </ul>
      <div on:click="{save}" class="save bottom">
        SAVE EVENT
      </div>
    </SectionNav>
  </div>
</div>